/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 15:14:40
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/shareConfig.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  mixins: [style],
  components: { Upload },
})
export default class ShareConfig extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: false })
    disabled: boolean;

  data: ItemObject = {};

  historyData: ItemObject = {};

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  mode = 0;

  // 1 网点配置 0 网点组配置
  @Prop({ default: 0 })
    fromPage: number;

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    this.historyData = o || n;
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  mounted() {
    this.mode = +this.$route.params.mode;
  }

  uploadImgSuccess(res) {
    this.data.shareInfo.sharePicture = res.content;
  }

  uploadCardSuccess(res) {
    this.data.shareInfo.shareCardPicture = res.content;
  }

  // 切换使用自定义分享图或默认分享图
  isUseDefaultShare(val) {
    this.$emit('change', val);
  }

  render(h) {
    return (
      <div class="share-config">
        <p class="title">分享海报配置</p>
        <el-form props={{ model: this.data }} show-message={false} label-position="left" label-width="80px" ref="form" disabled={this.disabled}>
          {!!this.fromPage && this.mode == 1 && (
            <el-radio-group v-model={this.data.isDefault} onChange={this.isUseDefaultShare.bind(this)}>
              <el-radio label={0}>使用默认分享图</el-radio>
              <el-radio label={1}>自定义分享图</el-radio>
            </el-radio-group>
          )}
          {((!!this.fromPage && this.data.isDefault) || !this.fromPage) && [
            <el-form-item label="海报图片" prop="shareInfo.sharePicture" rules={{ required: true, trigger: ['change'] }}>
              <Upload noDelete={false} onImgUploadSuccess={this.uploadImgSuccess.bind(this)} img={this.data.shareInfo.sharePicture} maxSize={2048} disabled={this.disabled} />
              <p class="tip">注1: 建议图片分辨率为500*500px</p>
              <p class="tip">注2: 图片大小不超过2M,支持jpg、jpeg、png、gif格式;</p>
            </el-form-item>,
            <el-form-item label="海报标题" prop="shareInfo.shareTitle" rules={{ required: true, trigger: ['change', 'blur'] }}>
              <el-input v-model={this.data.shareInfo.shareTitle}></el-input>
            </el-form-item>,
            <el-form-item label="海报描述" prop="shareInfo.description">
              <el-input type="textarea" v-model={this.data.shareInfo.description} autosize={{ minRows: 1, maxRows: 2 }}></el-input>
              <p class="tip r-mt-10">
                <span class="redText">*&nbsp;</span>海报描述在小程序中最大显示12个字
              </p>
            </el-form-item>,
            <p class="title">分享卡片配置</p>,
            <el-form-item label="卡片图片" prop="shareInfo.shareCardPicture" rules={{ required: true, trigger: ['change'] }}>
              <Upload noDelete={false} onImgUploadSuccess={this.uploadCardSuccess.bind(this)} img={this.data.shareInfo.shareCardPicture} maxSize={2048} disabled={this.disabled} />
              <p class="tip">注1: 建议图片分辨率为800*640px</p>
              <p class="tip">注2: 图片大小不超过2M,支持jpg、jpeg、png、gif格式;</p>
              {this.mode == 1 && <p class="tip">注3: 建小程序原生分享将默认使用该图片</p>}
            </el-form-item>,
          ]}
        </el-form>
      </div>
    );
  }
}
